export default {
	PHONECALLS_COLUMN_DATE: 'Data',
	PHONECALLS_COLUMN_DATE_FROM: 'Data inizio',
	PHONECALLS_COLUMN_DATE_TO: 'Data fine',
	PHONECALLS_COLUMN_RINGING_DURATION: 'Durata squillo',
	PHONECALLS_COLUMN_TALKING_DURATION: 'Durata chiamata',
	PHONECALLS_COLUMN_DIRECTION: 'Direzione',
	PHONECALLS_COLUMN_PHONE_NUMBER: 'Numero telefono',
	PHONECALLS_COLUMN_IS_ANSWERED: 'Risposta',
	PHONECALLS_COLUMN_PHONE_DESCRIPTION: 'Titolo telefono',
	PHONECALLS_COLUMN_PHONE_ITEM: 'Elemento collegato',
	PHONECALLS_COLUMN_PHONE_PERSON: 'Persona',
	PHONECALLS_COLUMN_PHONE_IMPORT_TYPE: 'Importata da',
	PHONECALLS_COLUMN_PHONE_CALL_USER: 'Utente',

	PHONECALLS_ACTIONS_VIEW_NOTES: 'Visualizza Note',
	PHONECALLS_ACTIONS_ADD_PERSON: 'Aggiungi Persona',
	PHONECALLS_ACTIONS_ADD_COMPANY: 'Aggiungi Azienda',
	PHONECALLS_ACTIONS_ADD_PHONE: 'Aggiungi Numero di Telefono',
	PHONECALLS_ACTIONS_ADD_ACTIVITY: 'Aggiungi Attività',
	PHONECALLS_DIALOG_VIEW_NOTES: 'Note',

	PHONECALLS_DIRECTION_INCOMING: 'Ricevuta',
	PHONECALLS_DIRECTION_OUTGOING: 'Effettuata',
	PHONECALLS_COUNT_IN: 'Ingresso',
	PHONECALLS_COUNT_OUT: 'Uscita',

	PHONECALLS_CHART_TOTAL_PHCA_DURATION: 'Totale chiamate: {value}',
	PHONECALLS_CHART_TOTAL_PHCA_DURATION_IN: 'Totale in Ingresso: {value}',
	PHONECALLS_CHART_TOTAL_PHCA_DURATION_OUT: 'Totale in Uscita: {value}',

	PHONECALLS_CHART_NO_COMPANY: 'Nessuna azienda',

	PHONECALLS_CHART_TITLE: "Telefonate nell'anno",
	PHONECALLS_PIECHART_COMPANIES_TITLE: 'Telefonate per Azienda',
	PHONECALLS_PIECHART_DIRECTION_TITLE: 'Telefonate per Direzione',

	DETAILS_PHONECALLS_FIELD_TITLE: 'Titolo',
	DETAILS_PHONECALLS_FIELD_COMPANIES: 'Azienda',
	DETAILS_PHONECALLS_FIELD_DATE_FROM: 'Data',
	DETAILS_PHONECALLS_FIELD_USER: 'Utente',
	DETAILS_PHONECALLS_FIELD_PERSON: 'Persona',
	DETAILS_PHONECALLS_FIELD_ANSWERED: 'Chiamata con risposta'
};
